(function () {
	'use strict';

	function _ddTarget() {
		return {
			restrict:'A',
			compile: function (element) {
				var contents = element.html();
				element.html('<div class="dd__content" style="margin:0 !important; padding:0 !important" >' + contents + '</div>');

				return function postLink(scope, element, attrs) {
					var duration = attrs.duration || '300ms';
					var easing = attrs.easing || 'ease-in-out';
					element.css({
						'height': '0px',
						'maxHeight': 'none',
						'overflow': 'hidden',
						'transitionProperty': 'height',
						'transitionDuration': duration,
						'transitionTimingFunction': easing
					});
				};
			}
		};
	}

	function _ddTrigger($timeout) {
		return {
			restrict: 'A',
			link: function(scope, element, attrs) {
				$timeout(function () {
					var target = document.querySelector(attrs.ddTrigger);
					var content = target.querySelector('.dd__content');
					var hasDropped = false;

					element.on('click', function () {
						if (hasDropped) {
							element[0].classList.remove('active');
							target.style.height = '0px';
							target.style.pointerEvents = 'none';
							target.style.zIndex = 998;
						} else {
							element[0].classList.add('active');
							content.style.border = '1px solid rgba(0,0,0,0)';
							var y = content.clientHeight;
							content.style.border = 0;
							target.style.height = y + 'px';
							target.style.pointerEvents = 'auto';
							target.style.zIndex = 999;
						}
						hasDropped = !hasDropped;
					});
				}, 0);
			}
		};
	}

	_ddTrigger.$inject = ['$timeout'];

	angular.module('KimaMain')
		.directive('ddTarget', _ddTarget)
		.directive('ddTrigger', _ddTrigger);

})();